import React from "react";

function AdReels({ data }) {
  // AdReel

  if (data) {
    var AdReel = data.AdReel.map(function (AdReel) {
      return (
        <a key={AdReel.title} href={AdReel.url} alt="" target="_blank">
          <div className="AdReel-Wrap">
            <img src={`${AdReel.image}`} alt="" />
            <video autoPlay={true} loop={true} muted={true} playsInline={true}>
              <source src={`${AdReel.video}`} type="" />
            </video>
          </div>
        </a>
      );
    });
  }

  return (
    <div className="AdR-main" id="Ads">
      <div className="AdR-Component">
        <h2>Celebrity Ads Portfolio</h2>
        {/* {AdReel} */}
        <div className="AdReel-Grid">{AdReel}</div>
      </div>
    </div>
  );
}

export default AdReels;
